import { render } from "./questions.vue?vue&type=template&id=25080467&scoped=true&ts=true"
import script from "./questions.vue?vue&type=script&lang=ts"
export * from "./questions.vue?vue&type=script&lang=ts"

import "./questions.vue?vue&type=style&index=0&id=25080467&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25080467"]])

export default __exports__